'use strict';

import jQuery from 'jquery';

window.$ = jQuery;
window.$_ = document.querySelector.bind(document);
window.$__ = document.querySelectorAll.bind(document);

